import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { startCase } from 'lodash'
import { selectedUrl } from '../../../../../../../../utils'


export function MonthItems({ index }) {
  const { title, description, due_date, status, url, kind, starts_at, ends_at, all_day, anchorDate } = props
  return (
    <div className={classnames("border-left border-right border-bottom p-2 hoverable clickable bg-white", { "border-top": index == 0 })}>
    </div>
  )
}



export function AgendaItem(props) {
  const { title, description, due_date, status, url, kind, starts_at, ends_at, all_day, anchorDate, index } = props
  return (
    <a href={url}
      target="_blank"
      className="border-rounded pt-2 pb-2 pl-3 pr-3 border d-block clickable hoverable mb-1 cursor-pointer bg-white"
      style={{textDecoration: 'none', color: 'black'}}>
      <div className="d-flex justify-content-between align-items-start">
        <small className="font-weight-bold text-secondary text-uppercase">{kind}</small>
        <b className="d-block">{title || 'No Title'}</b>
      </div>
      <div className="mt-1 mb-1"><Status status={status} anchorDate={anchorDate} /></div>
    </a>
  )
}

function Status(props){
  const { anchorDate } = props

  function getStatus(){
    switch (props.status) {
      case "no_checkin":
      case "current":
        if (moment(anchorDate).isBefore(moment().startOf("days"))){
          return props.status == "no_checkin" ? "missed" : 'overdue'
        } else {
          if (moment(anchorDate).startOf("days").isSame(moment().startOf("days"))){
            return 'pending'
          } else {
            return 'upcoming'
          }
        }
      case "pending_completing":
        return 'pending'
      default:
        return props.status
    }
  }
  const status = getStatus()

  return(
    <div className={classnames("badge p-1 text-uppercase",{
      " text-warning border-warning": status == 'pending',
      "text-danger border-danger": status == 'overdue' || status == 'missed' || status == 'Skipped',
      "badge-success": ( status == 'completed' || status == 'checked_in' || status == 'completed' ),
      "badge-warning": ( status == 'current' || status == 'no_checkin' ),
      "badge-secondary": status == 'upcoming' || status == 'Scheduled',
      "badge-danger": status == 'completed_late',
      })}>
      { startCase(getStatus()) }
    </div>
  )
}

export default function ResourceComponent(props){
  switch(props.resource_type){
    case "Event":
    case "Checkin":
      return <AgendaItem
        index={props.index}
        kind={"Event"}
        title={props.title}
        anchorDate={props.anchor_date}
        description={props.description}
        starts_at={props.starts_at}
        ends_at={props.ends_at}
        status={props.status}
        url={`/organizations/${props.organization.name}/events/${props.id}${props.status == 'pending_completing' ? '/review' : ''}?starts_at=${props.starts_at}&ends_at=${props.ends_at}`}
      />
    case "Goal":
      return <AgendaItem
        index={props.index}
        kind={props.resource_type}
        title={props.title}
        anchorDate={props.anchor_date}
        description={props.description}
        due_date={props.due}
        status={props.status}
        url={`/organizations/${props.organization.name}/goals/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "FormRequest":
      return <AgendaItem
        index={props.index}
        kind="Form Request"
        title={props.form.title}
        anchorDate={props.anchor_date}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/form_requests/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "SurveyRequest":
      return <AgendaItem
        index={props.index}
        kind="Survey Request"
        title={props.resident_survey.name}
        anchorDate={props.anchor_date}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={`/organizations/${props.organization.name}/survey_requests/${props.id}${props.status == 'pending_completing' ? '/review' : ''}`}
      />
    case "DrugTestRequest":
      return <AgendaItem
        kind="Drug Test Request"
        title={props.kind}
        anchorDate={props.anchor_date}
        description={props.notes}
        due_date={props.due_date}
        status={props.status}
        url={selectedUrl(props)}
      />
    default:
      return <div className="p-3 border mb-3 w-100">{JSON.stringify(props)}</div>
  }
}
